import { changeGazlift } from "./changeGazlift";
import { changeNozhkiStula } from "./changeNozhkiStula";
import { changeOpornoeKoltso } from "./changeOpornoeKoltso";

export const updateOporaDependencies = () => {
    if (servObj.activeNozhkiStula.length) {
        changeNozhkiStula(true);
    }
    if (servObj.activeGazlifts.length) {
        servObj.activeGazlifts.forEach((obj) => {
            const { type } = obj.userData;
            changeGazlift(true, type);
        });
    }
    if (servObj.activeOpornoeKoltso.length) {
        servObj.activeOpornoeKoltso.forEach(() => {
            changeOpornoeKoltso(true);
        });
    }
};
